import CarPageApp from './car-page-app';
import CarPageContactModal from './car-page-contact-modal';
import CarPageFinancialModal from './car-page-financing-modal';
import CarPageAddCartModal from './car-page-add-cart-modal';
import CarPageContactPanel from './car-page-contact-panel';

import LaakkonenFinancingFormTabs from './laakkonen-financing-form-tabs';
import FiksuGreenDiiliForm from './fiksugreendiili-form';
import PartPaymentFinancingForm from './partpayment-financing-form';
// import Header from './header'; // Doesn't look like this is needed right now, but it's okay code and has potential to be useful so let's hang on to it for a bit.
import misc from './car-page-misc-functionality';

import redirectToSellerVersion from './redirect-seller';

function init() {
  const mainCarPageGrid = document.querySelector('.car-page-grid');

  if (mainCarPageGrid) {
    redirectToSellerVersion();

    const carPageApp = new CarPageApp(mainCarPageGrid.dataset.license);
    new CarPageContactModal(carPageApp);
    new CarPageFinancialModal(carPageApp);
    new CarPageAddCartModal(carPageApp);
    new CarPageContactPanel(carPageApp);
    misc.init(carPageApp);

    PartPaymentFinancingForm.init(carPageApp);
    FiksuGreenDiiliForm.init(carPageApp);
    LaakkonenFinancingFormTabs.init(carPageApp);
    // Header.init(carPageApp); // Doesn't look like this is needed right now, but it's okay code and has potential to be useful so let's hang on to it for a bit.
  }
}

export { init };
